import gql from 'graphql-tag';

export const NORWEGIAN_POST_CITY = gql`
  query norwegianPostCity($zip: String!) {
    norwegianPostCity(zip: $zip)
  }
`;
